import {adminViewTranslations, AdminViewTranslations} from './admin/adminView.translations.pl';
import {loginViewTranslation, LoginViewTranslation} from './login/loginView.translation.pl.ts';
import {ProcessViewTranslation, processViewTranslations} from "./process/processView.translations.pl.ts";
import {validationTranslation, ValidationTranslation} from "./validation/validation.translation.pl.ts";
import {errorsTranslations, ErrorsTranslations} from "./process/errors/errors.translation.pl.ts";
import {serviceUnavailableTranslation, ServiceUnavailableTranslation} from "./serviceUnavailable/serviceUnavailable.translation.pl.ts";

export type ViewsTranslations = {
  admin: AdminViewTranslations;
  login: LoginViewTranslation;
  process: ProcessViewTranslation
  validation: ValidationTranslation
  errors: ErrorsTranslations
  serviceUnavailable: ServiceUnavailableTranslation
};

export const viewsTranslations: ViewsTranslations = {
  admin: adminViewTranslations,
  login: loginViewTranslation,
  process: processViewTranslations,
  validation: validationTranslation,
  errors: errorsTranslations,
  serviceUnavailable: serviceUnavailableTranslation
};
